import PropTypes from "prop-types";

const propTypes = {
  onBackClick: PropTypes.func.isRequired
};

export default propTypes;
